import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import StockoutproductDashboard from '../StockoutproductDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function StockoutproductPage() {
    const dispatch = useDispatch();
    const { stockoutproductList} = useSelector((state)=>state.manufslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':true}));
    },[]);

    return (
        < StockoutproductDashboard />
    )

}